import Vue from 'vue'
import moment from 'moment'
import { VueMaskFilter } from 'v-mask'

moment.locale('ru')

Vue.filter('formatDate', (date) => {
  return moment(date).format('DD.MM.YYYY')
})
Vue.filter('humanDate', (date) => {
  return moment(date).format('DD MMMM YYYY')
})

Vue.filter('human_date', (value) => {
  if (value) {
    return moment(value).format('DD MMM YYYY')
  }
  return ''
})

Vue.filter('robotDate', (date) => {
  return moment(date)
})
Vue.filter('optimalTitle', (title) => {
  if (title && title.length > 150) {
    return title.substring(0, 150) + '...'
  }
  return title
})
Vue.filter('findSource', (item, api) => {
  if (item.length) {
    if (item[0].get_img.url.substring(0, 4) === 'http') {
      return item[0].get_img.url
    } else if (item[0].get_img.media_server_url) {
      return item[0].get_img.media_server_url + '/' + item[0].get_img.url
    } else {
      return api + '/' + item[0].get_img.url
    }
  }
  return '/public/img/gallery-placeholder.svg'
})
Vue.filter('findSource2', (item, api) => {
  if (item.get_img.url.substring(0, 4) === 'http') {
    return item.get_img.url
  } else if (item.get_img.media_server_url) {
    return item.get_img.media_server_url + '/' + item.get_img.url
  } else {
    return api + '/' + item.get_img.url
  }
})
Vue.filter('getSrc', (item, api) => {
  if (item.img) {
    if (!item.img.url.startsWith('http')) {
      if (item.img.media_server_url) {
        return item.img.media_server_url + item.img.url
      } else if (item.img.url) {
        return api + '/' + item.img.url
      }
    } else {
      return item.img.url
    }
  }
  return '/public/img/gallery-placeholder.svg'
})
Vue.filter('findSourceSchool', (item, api) => {
  if (item.imgSchool) {
    if (item.imgSchool.substring(0, 4) === 'http') {
      return item.imgSchool
    }
    if (item.media_server_url) {
      return item.media_server_url + '/' + item.imgSchool
    }
    return api + '/' + item.imgSchool
  }
  return '/public/img/gallery-placeholder.svg'
})
Vue.filter('findSourceDocument', (item, api) => {
  if (item.url.substring(0, 4) === 'http') {
    return item.url
  } else if (item.media_server_url) {
    return item.media_server_url + '/' + item.url
  } else {
    return api + '/' + item.url
  }
})
Vue.filter('url', (url) => {
  const urlRegexp = new RegExp('^(http|https|ftp)')
  return urlRegexp.test(url) ? url : `https://${url}`
})
Vue.filter('vMask', VueMaskFilter)
